<script>
import Tooltip from 'tooltip.js';
import $ from 'domtastic';

import './stylesheets/components/VsHelp';

export default {
  props: {
    message: String,
    label: String,
    type: String,
    tooltipInnerId: String,
    marginLeft: [String, Boolean],
    marginRight: [String, Boolean],
    noMarginBottom: [String, Boolean],
  },
  data: () => ({
    tooltip: null,
  }),
  computed: {
    classes() {
      return {
        'vs-tooltip--margin-left': this.marginLeft,
        'vs-tooltip--margin-right': this.marginRight,
        'vs-tooltip--no-margin-bottom': this.noMarginBottom,
      };
    },
  },
  watch: {
    message() {
      this.$_destroy();
      this.$_create();
    },
  },
  mounted() {
    this.$_create();
  },
  beforeDestroy() {
    this.$_destroy();
  },
  methods: {
    $_create() {
      this.tooltip = new Tooltip(this.$refs.reference, {
        trigger: 'hover',
        placement: 'right',
        title: this.message,
        html: true,
        container: '#content',
      });

      // aria-describedby goes by ids. If one exists in the props, it means
      // that someone needs to use the inner-text id with an aria-describedby technique.
      if (this.tooltipInnerId) {

        // We need to do this so that we can get the id of the inner-text for aria purposes.
        // tooltip doesn't have a nice way to get the text container in their api.
        this.tooltip.show();
        this.tooltip.hide();

        let tooltipId = this.tooltip.reference.getAttribute('aria-describedby');
        let innerTextElement = $(`#${tooltipId}`).find(".tooltip-inner");

        innerTextElement.attr("id", this.tooltipInnerId);
      }

    },
    $_destroy() {
      if (this.tooltip) this.tooltip.dispose();
    },
  },
};
</script>

<template lang='pug'>
.vs-tooltip(:class='classes')
  label.vs-tooltip__label(v-if='label') {{label}}&nbsp;&nbsp;
  .vs-tooltip__icon(ref='reference')
    svg.h-1.w-1(
      v-if='!type'
      viewBox='0 0 24 24',
    )
      path.fill-current(d='M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z')
    svg.h-1.w-1(
      v-else-if='type === "alert"',
      viewBox='0 0 24 24',
    )
      path.fill-current(d='M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z')
</template>

<style>
.h-1 {
  height: 1.2rem;
}

.w-1 {
  width: 1.2rem;
}

.fill-current {
  fill: currentColor;
}
</style>